// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_15-7";
export var adjustableWidthBorderHeld = "_15-8";
export var arrow = "_15-3";
export var arrowButton = "_15-4";
export var headerCell = "_15-0";
export var help = "_15-2";
export var icon = "_15-1";
export var iconWrapper = "_15-6";
export var noBorder = "_15-b";
export var nonAdjustableWidthBorder = "_15-9";
export var nonAdjustableWidthBorderHeld = "_15-a";
export var textButton = "_15-5";